import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-star',
  templateUrl: './icon-star.component.html',
  styles: []
})
export class IconStarComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
